<template>
  <div class="container">
    <div class="title">您还没有选择专属下款产品</div>
    <div class="sub-title">平台为您精选<span>通过率95%</span>产品</div>
    <div class="products">
      <div class="product-item" v-for="item in items" 
           :key="item.configId"
           :data-sensors-exposure-property-product_code="item.configId"
           data-sensors-exposure-property-element_positon="product_pop"
           data-sensors-exposure-property-product_type="diversion"
           data-sensors-exposure-event-name="Diversion_Exposure"
      >
        <img class="product-item-icon" :src="item.icon">
        <div class="product-item-title">{{item.productName}}</div>
        <div class="product-item-info">{{item.productDesc}}</div>
      </div>
    </div>
    <nd-button class="confirm" @click="apply">确认申请</nd-button>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    apply () {
      // this.items.forEach(item => {
      //   this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_pop', product_code: item.configId })
      // })
      
      this.$emit('confirmApply')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";


.container {
  background-color: white;
  width: 620px;
  height: 520px;
  text-align: center;
  .title {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px
  }
  .sub-title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    margin-top: 8px;
    span {
      color: #FF4633
    }
  }
  .products {
    width: 560px;
    height: 240px;
    background: #FAFAFA;
    border-radius: 20px;
    border: 1px solid #FF4633;
    margin: 30px auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .product-item {
      padding: 0 15px;
      .product-item-icon {
        width: 60px;
        height: 60px;
        background-color: red;
        margin: 0 auto;
        border-radius: 6px;
      }
      .product-item-title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        margin-top: 13px;
      }
      .product-item-info {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 28px;
        margin-top: 11px;
      }
    }
  }
  .confirm {
    width: 440px;
    height: 80px;
    margin: 30px auto;
  }
}

</style>